import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import Iconify from 'src/components/iconify';

export default function ConnectModal(props) {
  const {open, onClose, onApply} = props

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          maxWidth: 344,
          width: '100%',
        },
      }}
    >
      <DialogTitle>
        <Stack direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography align='left' variant="h5">
            Подключение полной версии
          </Typography>
          <IconButton size="large" onClick={onClose}>
            <Iconify icon="solar:close-circle-bold" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        Ваша заявка отправлена. В ближайшее время менеджер с вами свяжется
      </DialogContent>
      <DialogActions>
        <Button
          size="large"
          onClick={onApply}
          variant="contained"
          fullWidth
        >
          Понятно
        </Button>
      </DialogActions>
    </Dialog>

  );
}
